import { getCookie, setCookie } from '@resources/js/helpers/cookies'


const initTabChange = ({ partnerUrl, beforeActionCallback }) => {
	if (getCookie('clkndr') || getCookie('tab-change')) return

	document.addEventListener('click', () => setCookie('interaction', 1))

	try {
		document.addEventListener(
			'visibilitychange',
			() => {
				if (document.hidden && getCookie('interaction') && !getCookie('clkndr')) {
					if (beforeActionCallback) beforeActionCallback()

					window.open(partnerUrl)

					setCookie('tab-change', 1)
				}
			},
			{ once: true }
		)
	} catch (error) {
		console.error(error)
		return null
	}
}

export default initTabChange
